/* ===================================
   Haven Golf Theme - theme.js
   =================================== */
(function () {
  'use strict';

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return [...(ctx || document).querySelectorAll(sel)]; }

  /* ---------- Cart count ---------- */
  async function fetchCartCount() {
    try {
      const r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const d = await r.json();
      qsa('.cart-count').forEach(el => {
        el.textContent = d.item_count;
        el.hidden = d.item_count === 0;
      });
    } catch (e) {}
  }

  /* ---------- Cart notification ---------- */
  function showCartNotification(msg) {
    const el = qs('.cart-notification');
    if (!el) return;
    const txt = qs('.cart-notification__text', el);
    if (txt) txt.textContent = msg || 'Added to cart!';
    el.removeAttribute('hidden');
    requestAnimationFrame(() => el.classList.add('is-visible'));
    clearTimeout(el._t);
    el._t = setTimeout(() => {
      el.classList.remove('is-visible');
      setTimeout(() => el.setAttribute('hidden', ''), 300);
    }, 2800);
  }

  /* ---------- Add to cart ---------- */
  function initCart() {
    document.addEventListener('submit', async function (e) {
      const form = e.target.closest('.product-form');
      if (!form) return;
      e.preventDefault();
      const btn = qs('[data-add-btn]', form) || qs('[name="add"]', form);
      const idInput = qs('[name="id"]', form);
      if (!idInput || !idInput.value) {
        alert('Please select your options.');
        return;
      }
      const defaultLabel = btn.dataset.labelDefault || 'Add to Cart';
      btn.textContent = btn.dataset.labelLoading || 'Adding...';
      btn.disabled = true;
      try {
        const r = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(idInput.value), quantity: 1 })
        });
        if (!r.ok) { const d = await r.json(); throw new Error(d.description || 'Error'); }
        fetchCartCount();
        showCartNotification('Added to cart!');
        btn.textContent = btn.dataset.labelAdded || 'Added!';
        btn.classList.add('is-added');
        setTimeout(() => { btn.textContent = defaultLabel; btn.classList.remove('is-added'); btn.disabled = false; }, 2000);
      } catch (err) {
        btn.textContent = defaultLabel; btn.disabled = false;
        alert(err.message || 'Could not add to cart. Please try again.');
      }
    });
    const closeBtn = qs('.cart-notification__close');
    if (closeBtn) closeBtn.addEventListener('click', () => {
      const el = qs('.cart-notification');
      el.classList.remove('is-visible');
      setTimeout(() => el.setAttribute('hidden', ''), 300);
    });
  }

  /* ---------- Product gallery ---------- */
  function initGallery() {
    qsa('[data-gallery]').forEach(gallery => {
      const mainImg = qs('[data-main-img]', gallery);
      const thumbs = qsa('[data-thumb]', gallery);
      const prevBtn = qs('[data-gallery-prev]', gallery);
      const nextBtn = qs('[data-gallery-next]', gallery);
      let idx = 0;
      function setActive(i) {
        idx = (i + thumbs.length) % thumbs.length;
        thumbs.forEach((t, j) => t.classList.toggle('is-active', j === idx));
        if (mainImg && thumbs[idx]) {
          const src = thumbs[idx].dataset.src || '';
          if (src) mainImg.src = src;
        }
      }
      thumbs.forEach((t, i) => t.addEventListener('click', () => setActive(i)));
      if (prevBtn) prevBtn.addEventListener('click', () => setActive(idx - 1));
      if (nextBtn) nextBtn.addEventListener('click', () => setActive(idx + 1));
    });
  }

  /* ---------- Variant selection ---------- */
  function initVariants() {
    qsa('[data-product]').forEach(wrap => {
      const jsonEl = qs('[data-variants-json]', wrap);
      if (!jsonEl) return;
      let variants;
      try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }
      const form = qs('.product-form', wrap);
      const idInput = form && qs('[name="id"]', form);
      const priceEl = qs('[data-price]', wrap);
      const comparePriceEl = qs('[data-compare-price]', wrap);
      const addBtn = form && qs('[data-add-btn]', form);
      const sizeBtns = qsa('.size-btn', wrap);
      let selectedOpts = variants[0] ? [...variants[0].options] : [];

      function findVariant(opts) {
        return variants.find(v => v.options.every((o, i) => o === opts[i]));
      }
      function moneyFmt(cents) {
        return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
      }
      function update() {
        const v = findVariant(selectedOpts) || variants.find(x => x.available) || variants[0];
        if (!v) return;
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = moneyFmt(v.price);
        if (comparePriceEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            comparePriceEl.textContent = moneyFmt(v.compare_at_price);
            comparePriceEl.hidden = false;
          } else { comparePriceEl.hidden = true; }
        }
        if (addBtn) {
          addBtn.disabled = !v.available;
          addBtn.textContent = v.available ? (addBtn.dataset.labelDefault || 'Add to Cart') : (addBtn.dataset.labelSoldout || 'Sold Out');
        }
        const colorLabel = qs('[data-color-label]', wrap);
        if (colorLabel && v.options[0]) colorLabel.textContent = v.options[0];
      }
      sizeBtns.forEach(btn => {
        btn.addEventListener('click', function () {
          const optIdx = parseInt(this.dataset.optIndex || '0');
          selectedOpts[optIdx] = this.dataset.value;
          sizeBtns.filter(b => parseInt(b.dataset.optIndex || '0') === optIdx).forEach(b => b.classList.toggle('is-active', b === this));
          update();
        });
      });
      qsa('.color-swatch', wrap).forEach((sw, i) => {
        sw.addEventListener('click', function () {
          qsa('.color-swatch', wrap).forEach(s => s.classList.remove('is-active'));
          this.classList.add('is-active');
          selectedOpts[0] = this.dataset.value;
          update();
        });
      });
      update();
    });
  }

  /* ---------- Carousels ---------- */
  function initCarousels() {
    qsa('[data-carousel-wrap]').forEach(wrap => {
      const track = qs('[data-carousel]', wrap);
      const prev = qs('[data-carousel-prev]', wrap);
      const next = qs('[data-carousel-next]', wrap);
      if (!track) return;
      function scroll(dir) { track.scrollBy({ left: dir * Math.min(track.clientWidth * 0.8, 540), behavior: 'smooth' }); }
      if (prev) prev.addEventListener('click', () => scroll(-1));
      if (next) next.addEventListener('click', () => scroll(1));
    });
  }

  /* ---------- Accordions ---------- */
  function initAccordions() {
    qsa('.accordion__trigger').forEach(btn => {
      btn.addEventListener('click', function () {
        const acc = this.closest('.accordion');
        acc.classList.toggle('is-open');
      });
    });
    qsa('.accordion[data-default-open]').forEach(a => a.classList.add('is-open'));
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    const shopMens = qs('.shop-mens');
    function checkMens() {
      if (!shopMens) return;
      const r = shopMens.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.85 && r.bottom > 0) {
        shopMens.classList.add('is-revealed');
        window.removeEventListener('scroll', checkMens);
      }
    }
    const revEls = qsa('.reveal, .reveal-scale');
    function checkReveal() {
      revEls.forEach(el => {
        if (el.classList.contains('is-visible')) return;
        const r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 0.9 && r.bottom > 0) el.classList.add('is-visible');
      });
    }
    checkMens(); checkReveal();
    window.addEventListener('scroll', checkMens, { passive: true });
    window.addEventListener('scroll', checkReveal, { passive: true });
    window.addEventListener('resize', checkReveal, { passive: true });
    setTimeout(() => { if (shopMens) shopMens.classList.add('is-revealed'); revEls.forEach(el => el.classList.add('is-visible')); }, 2000);
  }

  /* ---------- Mobile nav ---------- */
  function initMobileNav() {
    const toggle = qs('.nav-toggle');
    const nav = qs('.site-nav');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', function () {
      const open = nav.classList.toggle('is-open');
      this.setAttribute('aria-expanded', String(open));
    });
  }

  /* ---------- Newsletter ---------- */
  function initNewsletter() {
    qsa('.newsletter-form').forEach(form => {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        const input = qs('input[type="email"]', form);
        if (!input || !input.value.includes('@')) { if (input) input.style.outline = '2px solid #c0392b'; return; }
        const success = qs('.newsletter-success', form.closest('.footer-newsletter, .newsletter-section'));
        if (success) { success.removeAttribute('hidden'); success.style.display = ''; }
        form.style.display = 'none';
      });
    });
  }

  /* ---------- Init ---------- */
  function init() {
    fetchCartCount();
    initCart();
    initGallery();
    initVariants();
    initCarousels();
    initAccordions();
    initReveal();
    initMobileNav();
    initNewsletter();
  }

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
